import { CustomerPreferenceOutDto } from '@app/swagger-types';
import { format } from 'date-fns';
import { FORMAT } from '@app/constants/formats';
import { EmailCard } from '../../shared/EmailCard';
import { StatusPill } from '../../shared/StatusPill';

// admin-emailbeheer blok A stap 5, opdracht §5 "Voorkeurenblok": all four categories always
// shown, plus - for every opted-out one - when and through what that happened. Per
// EmailCustomerAdminFacadeImpl, this list always has all four EEmailCategory values, not just
// the ones with an email_preference row.
export const CustomerPreferencesBlock: React.FC<{ preferences: CustomerPreferenceOutDto[] }> = ({ preferences }) => {
  return (
    <EmailCard title="Preferences">
      <table className="w-full text-left text-xs">
        <tbody>
          {preferences.map((preference, i) => (
            <tr key={preference.category} className={i % 2 === 1 ? 'bg-gray-50' : undefined}>
              <td className="font-mono py-1.5 pr-3">{preference.category}</td>
              <td className="py-1.5 pr-3 text-gray-500">
                {!preference.optedIn && (
                  <>
                    {preference.source}
                    {preference.optedOutAt && <> - {format(new Date(preference.optedOutAt), FORMAT.FULL_TIME)}</>}
                  </>
                )}
              </td>
              <td className="py-1.5 text-right">
                <StatusPill variant={preference.optedIn ? 'ok' : 'mut'}>{preference.optedIn ? 'on' : 'off'}</StatusPill>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </EmailCard>
  );
};
